import React, { Fragment } from "react";
import tw from "twin.macro";
import { withSections } from "./withSections";

const Container = tw.div`
  [scroll-mt:140px]
`;

export const Sections = withSections(({ content }) => {
  return (
    <Fragment>
      {content?.filter(Boolean).map((section) => {
        const {
          key,
          anchorId,
          component: Component,
          nested,
          ...rest
        } = section;
        return (
          <Fragment key={key}>
            {anchorId ? (
              <Container data-testid={anchorId} id={anchorId}></Container>
            ) : null}
            {Component ? (
              <Component
                as={nested ? "div" : "section"}
                nested={nested}
                {...rest}
              />
            ) : null}
          </Fragment>
        );
      })}
    </Fragment>
  );
});
